import React from 'react';

import { motion } from 'framer-motion';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';

import Icon from '../../../../utils/icon';
import SaveAltIcon from '@material-ui/icons/SaveAlt';

import headerimage from '../../../../images/education-banner.png';

const useStyles = makeStyles((theme) => ({
  pageheader: {
    backgroundImage: "url('" + headerimage + "')",
    height: 405,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    marginBottom: theme.spacing(8),
  },
  pageheaderelement: {
    opacity: 0,
    height: '100%',
    right: '-400px',
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  pageheaderelementimage: {
    position: 'absolute',
    height: '135%',
    bottom: 0,
    right: 0,
  },
  datepublished: {
    fontStyle: 'italic',
    color: theme.palette.primary.light,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  cardcontenttype: {
    backgroundColor: theme.palette.primary.highlight,
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(2),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1,
  },
}));

const listCategories = (categoriesitem) => {
  return categoriesitem.map((item, index) => {
    return (
      <Box
        key={index}
        width={42}
        height={42}
        borderRadius={100}
        className={item.name}
        display='flex'
        alignItems='center'
        justifyContent='center'
        ml={1}
      >
        <Icon name={item.name} color='#ffffff' widthsize={30} heightsize={30} />
        {/*{console.log(item.name)}*/}
      </Box>
    );
  });
};

const listPdf = (pdfitem) => {
  return pdfitem.map((item, index) => {
    return (
      <IconButton
        key={index}
        href={item.craftercms.path}
        download
        color='secondary'
      >
        <SaveAltIcon />
      </IconButton>
    );
  });
};

export default function TradePresenterPageHeader(props) {
  const { ice } = props;

  const classes = useStyles();
  return (
    <Box pb={4} className={classes.pageheader + ' print-reset-height'}>
      <motion.div
        className={classes.pageheaderelement}
        animate={{ opacity: [0, 0, 0, 0.25, 0.5, 0.75, 1], right: 0 }}
        transition={{ ease: 'easeInOut', duration: '0.6' }}
      >
        <Box height={1} position='relative' bottom={0} right={0}>
          <img
            src={props.pageheaderimage}
            alt={props.title}
            className={classes.pageheaderelementimage}
          />
        </Box>
      </motion.div>
      <Box width={1} position='absolute' bottom='-30px'>
        <Container maxWidth='lg'>
          <Box bottom={32} className='page-header-width'>
            <Typography {...ice} variant='h2' gutterBottom>
              {props.title}
            </Typography>
            <Box mb={2}>
              <Typography {...ice} variant='body1' gutterBottom>
                {props.subtitle}
              </Typography>
            </Box>
          </Box>
        </Container>
        <Container maxWidth='lg' className='no-print'>
          <Box
            width={1}
            bgcolor='#ffffff'
            mt={2}
            py={1}
            px={2}
            borderRadius={32}
            className='item-boxshadow'
            display='flex'
            alignItems='center'
            justifyContent='space-between'
          >
            <Box>
              <Typography
                variant='overline'
                className={classes.cardcontenttype}
                gutterBottom
              >
                Practitioner Guide
              </Typography>
            </Box>
            <Box display='flex' alignItems='center'>
              {props.pdf && listPdf(props.pdf)}
              {props.categories && listCategories(props.categories)}
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
